import { IAssignmentLogger, IAssignmentEvent } from '@eppo/js-client-sdk';

import { sendBpEventWithContexts } from '@vimeo/use-tracking';

import { bigPictureEventName, bigPictureEventSchemaVersion } from '../constants';

class BigPictureAssignmentLogger implements IAssignmentLogger {
  logAssignment(assignment: IAssignmentEvent): void {
    const {
      allocation,
      experiment,
      featureFlag,
      subject,
      subjectAttributes,
      variation,
      extraLogging,
      sdkMetadata,
    } = assignment;
    const { bigPictureContexts, ...remainingSubjectAttributes } = subjectAttributes;

    const fields = {
      experiment: experiment ?? '',
      subject: subject,
      variation: variation ?? '',
      subject_attributes: JSON.stringify(remainingSubjectAttributes),
      feature_flag: featureFlag,
      allocation: allocation ?? '',
      extra_logging: extraLogging ? JSON.stringify(extraLogging) : null,
      sdk_metadata: sdkMetadata ? JSON.stringify(sdkMetadata) : null,
    };

    sendBpEventWithContexts(
      bigPictureEventName,
      JSON.parse(bigPictureContexts),
      bigPictureEventSchemaVersion,
      fields,
    );
  }
}

export default BigPictureAssignmentLogger;
